module.exports = __webpack_public_path__ + "img/shopping.8a1abf67.svg";